<template>
  <div class="example">
    <div class="example_title">行业案列</div>
    <div class="example_content">
      <ul>
        <li>
          <p>
            <img
              src="https://ar-scene-source.nosdn.127.net/a257dc0a451ab8b04010c01c0ffcaad2.jpg"
              alt=""
            />
          </p>
          <p>
            <span>敦煌艺术展</span>
            <span>敦煌AR智能导览</span>
          </p>
        </li>
        <li>
          <p>
            <img
              src="https://ar-scene-source.nosdn.127.net/4664581a0fd2eeb4c6a58cd52eef6d5f.png"
              alt=""
            />
          </p>
          <p>
            <span>企业AR数字展厅</span>
            <span>钉钉发布了AR数字展厅解决方案</span>
          </p>
        </li>
        <li>
          <p>
            <img
              src="https://ar-scene-source.nosdn.127.net/ab06a71c41264527a18a6ec77c61d554.png"
              alt=""
            />
          </p>
          <p>
            <span>杭州天目里首个AR展</span>
            <span
              >由易现携手想象力学实验室与俞同舟共同构建的《全息甲板HOLODECK》首个AR艺术展在杭州天目里举办</span
            >
          </p>
        </li>
        <li>
          <p>
            <img
              src="https://ar-scene-source.nosdn.127.net/7cee0a81362bab1e0634e52f7b05a72c.jpg"
              alt=""
            />
          </p>
          <p>
            <span>口子酒文化博物馆</span>
            <span
              >易现携手口子酒文化博物馆，通过增强现实（AR）技术还原源远流长的酿酒历史</span
            >
          </p>
        </li>
      </ul>
    </div>
    <div class="example_more">了解更多</div>
    <div class="zhanwei"></div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less">
@import url("@/statis/css/base.less");

.example {
  width: 100%;
  height: auto;
  background: #fafcff;

  &_title {
    font-size: 36px;
    font-weight: 400;
    color: #000;
    user-select: none;
    line-height: 6vw;
  }

  &_content {
    width: 100%;
    height: 15vw;

    ul {
      width: 70%;
      height: 100%;
      margin: auto;
      .fixcenter();
      justify-content: space-around;
      align-items: start;

      li {
        width: 19%;
        height: 90%;
        transition: all 0.3s;
        box-shadow: 0px 8px 8px 0px rgb(239 242 249 / 50%);
        border: 1px solid #e6edfa;

        p {
          &:nth-child(1) {
            width: 100%;
            height: 60%;

            img {
              width: 100%;
              height: 100%;
            }
          }

          &:nth-child(2) {
            width: 100%;
            height: 40%;
            display: flex;
            justify-content: space-between;
            flex-direction: column;

            span {
              display: flex;
              justify-content: start;
              align-items: center;
              width: 100%;
              height: 50%;
              padding: 0 20px;
              box-sizing: border-box;

              &:nth-child(1) {
                align-items: flex-end;
                font-size: 24px;
                font-weight: bold;
                cursor: pointer;
              }

              &:nth-child(2) {
                color: #b7b1b1;
                text-align: left;
                line-height: 1vw;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }

        &:hover {
          transform: translateY(-20px);
          box-shadow: 0px 8px 18px 0px rgba(172, 173, 177, 0.5);

          p {
            &:nth-child(2) {
              span {
                &:nth-child(1) {
                  color: rgb(64, 36, 222);
                }
              }
            }
          }
        }
      }
    }
  }

  &_more {
    width: 100px;
    height: 50px;
    background: rgb(100, 64, 200);
    margin: auto;
    .fixcenter();
    color: #fff;
    cursor: pointer;
    margin-top: 3vw;

    &:hover {
      background: rgb(124, 97, 199);
    }
  }

  .zhanwei {
    width: 100%;
    height: 4vw;
  }
}

@media (max-width: 1920px) {
  .example {
    &_title {
      line-height: 15vw;
    }

    &_content {
      height: 27vw;

      ul {
        width: 90%;
        height: 24vw;

        li {
          width: 22%;

          p {
            &:nth-child(2) {
              span {
                &:nth-child(1) {
                  font-size: 20px;
                  height: 30%;
                }

                &:nth-child(2) {
                  height: 70%;
                  font-size: 13px;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 550px) {
  .example {
    &_title {
      line-height: 15vw;
      font-size: 6vw;
      font-weight: bold;
    }

    &_content {
      height: 95vw;
      overflow: scroll;

      ul {
        width: 310vw;
        height: 100%;
        display: block;
        display: flex;
        justify-content: space-around;
        align-items: center;

        li {
          width: 70vw;
          display: inline-block;

          p {
            &:nth-child(1) {
              height: 43%;
            }

            &:nth-child(2) {
              span {
                &:nth-child(1) {
                  font-size: 5vw;
                  height: 30%;
                }

                &:nth-child(2) {
                  height: 70%;
                  font-size: 3.6vw;
                  line-height: 6vw;
                  align-items: start;
                  padding: 6vw;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
